export default __webpack_public_path__ + "static/radler-logo-59c4b5a0f4b052d7fd1c0a16a238f8cf.svg";